import { breakpoints } from '@coursera/cds-common';

import type { CloseButtonProps } from '@core/dialogs/common/CloseButton';
import { CloseButton } from '@core/dialogs/common/CloseButton';
import { useMediaQuery } from '@core/utils';

import { useDialogContext } from './DialogContextProvider';
import {
  getCloseCss,
  getCloseButtonBackgroundCss,
  isCloseAlwaysAbsolute,
} from './styles';

export type Props = {
  showCloseAction: boolean;
  onClose?: CloseButtonProps['onClick'];
};

export const Close = (props: Props) => {
  const { showCloseAction, onClose } = props;

  const {
    invert,
    color,
    variant,
    sticky,
    slotOrientation,
    closeAbsoluteOnMobile,
    width,
  } = useDialogContext();

  const isXs = useMediaQuery(breakpoints.down('xs'));
  const isAbsolute = isCloseAlwaysAbsolute(slotOrientation);

  // When close button is always absolute (over slot), use dark icon since
  // white circular background is always shown. Otherwise use dialog color-based invert.
  // For absoluteOnMobile, CSS handles icon color override at mobile breakpoint.
  const applyAbsoluteOnMobile = closeAbsoluteOnMobile && isXs;
  const shouldInvert = isAbsolute || applyAbsoluteOnMobile ? false : invert;

  return (
    <div
      css={getCloseCss({
        color,
        variant,
        sticky: sticky === 'headingGroup',
        isAbsolute,
        absoluteOnMobile: closeAbsoluteOnMobile,
        width,
      })}
    >
      {showCloseAction && (
        <div
          css={getCloseButtonBackgroundCss({
            isAbsolute,
            absoluteOnMobile: closeAbsoluteOnMobile,
          })}
        >
          <CloseButton invert={shouldInvert} onClick={onClose} />
        </div>
      )}
    </div>
  );
};
